// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraInstrumentLookup } from './Lookup/TerceraInstrumentLookup';
export class QuickTableInstrumentLookup extends TerceraInstrumentLookup {
    constructor(initProps, data, callback, rect) {
        super();
        this._isProcessedCallback = false;
        this.tag = data;
        this.callback = callback;
        this.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
        void this.set('isPosAbsolute', true);
    }
    oncomplete() {
        super.oncomplete();
        const selectedInstrument = this.tag.cell.QuickTableEditingInfo.GetDataHandler();
        void this.set('selectedItem', selectedInstrument);
        void this.set('visible', true);
        this.setFocus();
    }
    runCallback(instrument) {
        this._isProcessedCallback = true;
        this.callback(instrument, this.tag);
    }
    onLostFocus() {
        if (!this.get('isFormShowed')) {
            this.callback(undefined, this.tag);
        }
    }
    closeForm() {
        super.closeForm();
        if (!this._isProcessedCallback) {
            this.onLostFocus();
        }
    }
}
TerceraInstrumentLookup.extendWith(QuickTableInstrumentLookup, {
    data: function () {
        return {
            zIndex: 1
        };
    }
});
